module.exports = __webpack_public_path__ + "img/shizipeixun.38416dad.png";